import dev from './dev';
import prod from './prod';

let cfg = {};
const node_env = process.env.NODE_ENV;
var type = process.env.BUILD_TYPE;
if(node_env === 'production') {
    if (type === 'test') {
        cfg = dev;
    } else {
        cfg = prod;
    }
} else {
    cfg = dev;
}



export default cfg;



// WEBPACK FOOTER //
// ./src/common/config/index.js